<template>
  <div class="finishPage">
    <div class="finishPage__content">
      <div class="finishPage__mainText">
        <slot name="mainText"></slot>
      </div>
      <div class="finishPage__infoText">
        <slot name="infoText"></slot>
      </div>
    </div>
    <ActionButton
        v-if="buttonCaption"
        style="width: 180px"
        icon-type="arrow"
        @button-click="$router.push(exitRoute)"
    >
      <template #caption> {{ buttonCaption }}</template>
    </ActionButton>
  </div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";

export default {
  name: "FinishPage" ,
  components: {ActionButton},
  props: ['buttonCaption', 'exitRoute']
}
</script>


<style scoped lang="scss">
.finishPage {
  height: 410px;
  border-radius: 20px;
  padding: 34px;
  opacity: 1;
  background: var(--cd-card-bg);
  text-align: center;

  &__content {
    width: 498px;
    margin: 0 auto;
  }

  &__mainText {
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: 36px;
    margin: 65px 0;
  }

  &__infoText {
    margin: 40px 34px;
    font-size: 16px;
    font-family: var(--cd-default-font);

    a {
      color: #62C064;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
